import { AlertCircle } from 'lucide-react';
import type { PreviewResp } from '@/api/types';
import { cn } from '@/lib/utils';

export default function PreviewResult({ resp }: { resp: PreviewResp }) {
  const out = resp.script_output;
  return (
    <div
      className={cn(
        'rounded-md border bg-card p-3 space-y-2',
        resp.error && 'border-destructive/40 bg-destructive/5',
      )}
    >
      <div className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        Preview result
      </div>
      {resp.error && (
        <div className="text-xs text-destructive flex items-start gap-1.5">
          <AlertCircle className="h-3.5 w-3.5 shrink-0 mt-0.5" />
          <span>{resp.errorMessage || 'Preview failed'}</span>
        </div>
      )}
      {resp.infos && resp.infos.length > 0 && (
        <ul className="text-[11px] text-muted-foreground space-y-0.5">
          {resp.infos.map((info, i) => (
            <li key={i}>· {info}</li>
          ))}
        </ul>
      )}
      {out && (out.measurement_output_type === 'json' || out.total != null) && (
        <table className="text-xs">
          <tbody>
            <Row label="Total" value={String(out.total ?? '—')} />
            <Row label="Total usage" value={String(out.total_usage ?? '—')} />
            <Row label="Non-batch usage" value={String(out.non_batch_usage ?? '—')} />
            <Row label="Available" value={out.available ?? '—'} />
          </tbody>
        </table>
      )}
      {resp.output && resp.output.length > 0 && (
        <pre className="text-xs font-mono bg-muted/40 rounded p-2 max-h-40 overflow-y-auto">
          {resp.output.join('\n')}
        </pre>
      )}
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <tr>
      <td className="pr-3 py-0.5 text-muted-foreground">{label}</td>
      <td className="font-mono">{value}</td>
    </tr>
  );
}
